const notification = {
  "item.1.title": "WARS Staking is now available",
  "item.1.action": "Stake Now",
  "item.1.date": "Oct 28 (Wed)",
  "item.2.title": "LP Staking is now available",
  "item.2.action": "Stake Now",
  "item.2.date": "Oct 28 (Wed)",
};
export default notification;
